define("ROOM4.CCAProductGallery.CCAProductGalleryHeader.View", [
  "Backbone",
  "ROOM4.CCAProductGallery.CCAProductGalleryHeader.TextSearch.View",
  "room4_ccaproductgallery_header.tpl",
], function (Backbone, GalleryTextSearchView, template) {
  "use strict";

  return Backbone.View.extend({
    template: template,

    initialize: function initialize(options) {
      this.pageHeading = options.pageHeading;
      this.textSearchEnabled = options.textSearchEnabled;
      this.getTranslator = options.getTranslator;
    },

    childViews: {
      "CCAProductGalleryHeader.TextSearch": function () {
        return new GalleryTextSearchView({
          getTranslator: this.getTranslator,
        });
      },
    },

    getContext: function getContext() {
      return {
        pageHeading: this.pageHeading,
        textSearchEnabled: this.textSearchEnabled,
      };
    },
  });
});
